<mat-toolbar class="main-toolbar">
  <mat-toolbar-row class="toolbar-container">
    <a routerLink="/guadalajara" class="toolbar-left">
      <img src="assets/AZ_logo.svg" alt="AZ Logo" class="logo-az" />
      <img src="assets/TSM_logo.svg" alt="AZ Logo" class="logo-az" />
    </a>
    <div class="toolbar-center">
      <nav>
        <a
          routerLink="/chennai"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }"
          class="toolbar-link"
        >
          Chennai
        </a>
        <a
          routerLink="/guadalajara"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: false }"
          class="toolbar-link"
        >
          Guadalajara
        </a>
      </nav>
    </div>

    <div class="toolbar-right">
      <img
        [src]="getPictureURL()"
        alt="Perfil"
        class="profile-image"
        (click)="navigateToAdmin()"
      />
    </div>
  </mat-toolbar-row>
</mat-toolbar>
